module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_6005.b8d6dce2.png";